// Simple MediaRecorder wrapper for microphone capture
export const audioService = {
  isSupported() {
    return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
  },

  async startRecording() {
    if (!this.isSupported()) {
      throw new Error('MediaDevices API not supported in this browser');
    }

    // request mic
    const stream = await navigator.mediaDevices.getUserMedia({
      audio: {
        echoCancellation: true,
        noiseSuppression: true,
        sampleRate: 44100,
      },
    });

    const chunks = [];
    let recorder;
    let stopped = false;

    const mimeType = 'audio/webm;codecs=opus';
    try {
      recorder = new MediaRecorder(stream, { mimeType, audioBitsPerSecond: 128000 });
    } catch (e) {
      // Fallback without explicit mimeType
      recorder = new MediaRecorder(stream);
    }

    recorder.ondataavailable = (e) => {
      if (e.data && e.data.size > 0) chunks.push(e.data);
    };

    const stopTracks = () => {
      stream.getTracks().forEach((t) => t.stop());
    };

    const stop = () =>
      new Promise((resolve) => {
        if (stopped) {
          resolve(new Blob([], { type: 'audio/webm' }));
          return;
        }
        stopped = true;
        recorder.onstop = () => {
          const blob = new Blob(chunks, { type: 'audio/webm' });
          stopTracks();
          resolve(blob);
        };
        try {
          recorder.stop();
        } catch (_) {
          // ignore
          stopTracks();
          resolve(new Blob([], { type: 'audio/webm' }));
        }
      });

    recorder.start(500); // timeslice for ondataavailable

    return { stop };
  },

  createObjectUrl(blob) {
    return URL.createObjectURL(blob);
  },
  revokeObjectUrl(url) {
    URL.revokeObjectURL(url);
  },
};
